<template>
  <div>
    <div id="firstMenubar" class="row roundedtop menubar">
      <div class="title">Berichten</div>
      <a
        v-if="style == 'db' && Number(role) === 2"
        href="https://www.doelbeleggen.nl/agenda/atp"
        target="_blank"
        class="button"
        style="float:right;"
      >
        <awesomeIcon icon="phone-alt"/> <span class="mobile-hidden">Plan een belafspraak in</span>
      </a>
      <a
        v-else-if="style=='db'"
        href="https://www.doelbeleggen.nl/content/uploads/Voorwaarden-online-machtiging-adviseur.pdf"
        target="_blank"
        class="button"
        style="float:right;"
      >
        <awesomeIcon icon="handshake"/> <span class="mobile-hidden">Lees Voorwaarden</span>
      </a>
    </div>
    <div class="card inset-small marginbottom roundedBottom" v-if="Number(role) === 2">
      <h3 class="backgroundTitle">Samen Doelbeleggen - dé portal voor adviserend Nederland</h3>
      <p style="line-height: 150%">
        U bent in uw berichten overzicht.
      </p>
    </div>

    <modalWindow v-if="read!=null" @close="read=null" width="400">
      <div class="titlebar">{{ new Date(read.created).toLocaleString() }}</div>
      <div class="inset">
        <template v-if="read.title !== 'OXBYDB'">
          <b>{{ read.title }}</b>
          <br /><br />
        </template>
        <span v-html="read.message" />
        <button
          style="width:100%; margin-bottom:5px;"
          v-for="(file, index) in read.files" :key="index" @click="download(file)"
        >
          <awesomeIcon icon="upload" />
          {{file.replace(/upload\-\d+\-(.*)/, '$1').slice(0, 30)}}
          {{file.replace(/upload\-\d+\-(.*)/, '$1').length > 30 ? '&mldr;' : ''}}
        </button>
      </div>
    </modalWindow>

    <div key="messages" class="card" v-if="messages !== null">
        <span
          v-if="Object.keys(messages).length == 0"
          class="icon msg" style="margin: 0; border-radius: 0"
        >
          <span class="icon">
            <awesomeIcon icon="exclamation-circle" />
          </span>
          U heeft nog geen berichten
        </span>
      <template v-else>
        <table class="new">
          <tr>
            <th :width="isMobile() ? '75px' : '140px'">Datum</th>
            <th>Bericht</th>
            <th :width="isMobile() ? '20px' : '115px'" @click="setReadAll" class="link">
              <template
                v-if="(messages !== null && Object.keys(messages).length > 0)"
              >
                <awesomeIcon icon="envelope-open-text" />
                <template v-if="!isMobile()"> Alles gelezen</template>
              </template>
            </th>
          </tr>
        </table>
        <table class="new click-tr">
          <tr
            v-for="message in messages"
            :key="message.id"
            :class="{ unread: !message.read }"
            @click="read = message; setRead(message.id);"
          >
            <td :width="isMobile() ? '75px' : '140px'">
              {{ new Date(message.created).toLocaleString() }}
            </td>
            <td class="message">
              <span class="txt">
                <awesomeIcon icon="bell" v-if="message.read === null" />
                <awesomeIcon icon="file" v-if="message.files.length > 0" />
                {{
                  message.title === 'OXBYDB'
                    ? 'OXBY en Doelbeleggen.nl'
                    : message.title
                }}
                {{
                  message.title === 'OXBYDB'
                    ? ''
                    : `- ${removeHtml(message.message)}`
                }}
              </span>
            </td>
            <td class="link" :width="isMobile() ? '20px' : '61px'">
              <span class="hide-mobile">Bekijk</span>
              <awesomeIcon icon="search" />
            </td>
          </tr>
        </table>
        <pagerElement
          v-model="currentPage"
          :records="totalMessages"
          :resultsPerPage="maxPerPage"
        />
      </template>
    </div>
    <div key="loader" v-else class="loader" />
  </div>
</template>

<script>
export default {
  name: 'UserMessages',
  data() {
    return {
      read: null,
      messages: null,
      currentPage: 0,
      totalMessages: 0,
      maxPerPage: 20,
      style: process.env.VUE_APP_STYLE,
    };
  },
  created() {
    this.getMessages();
    this.$parent.hasStickyMenu = true;
  },
  unmounted() {
    this.$parent.hasStickyMenu = false;
  },
  watch: {
    currentPage() {
      this.getMessages();
    },
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
  },
  methods: {
    removeHtml(text) {
      return text.replace(/(<([^>]+)>)/ig, '');
    },
    getMessages() {
      let filter = [];
      filter = filter.join(';');
      this.sdk.getMessages((response) => {
        if (response.status === 200) {
          for (let i = 0; i < response.data.results.length; i += 1) {
            const matches = response.data.results[i].message.match(/\[file](.*?)\[\/file]/g);
            response.data.results[i].files = [];
            if (matches) {
              for (let j = 0; j < matches.length; j += 1) {
                response.data.results[i].files.push(matches[j].replace(/\[file](.*?)\[\/file]/g, '$1'));
              }
            }
            response.data.results[i].message = response.data.results[
              i
            ].message.replace(/\[file](.*?)\[\/file]/g, '');
          }
          this.messages = response.data.results;
          this.totalMessages = response.data.totalRows;
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      }, filter, this.currentPage, this.maxPerPage);
    },
    setRead(message) {
      this.sdk.setMessageRead(message, () => {
        this.sdk.getUnreadMessages((response) => {
          if (response.status === 200) {
            this.$store.state.unread = response.data;
            this.getMessages();
          }
        });
      });
    },
    setReadAll() {
      this.sdk.setAllMessageRead(() => {
        this.sdk.getUnreadMessages((response) => {
          if (response.status === 200) {
            this.$store.state.unread = response.data;
            this.getMessages();
          }
        });
      });
    },
    download(file) {
      this.sdk.getPublicFile(file);
    },
    isMobile() {
      if (
        window.matchMedia('(max-width: 800px)').matches
        && /Mobi/.test(navigator.userAgent)
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.unread {
  font-weight: 600;
  color: #000;
}
.txt {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  width: 100%;
}
.card {
  padding: 20px;
  @media #{$mobile} {
    padding: 1px 2px 2px;
  }
}
table {
  @media #{$mobile} {
    &.activities {
      table-layout: initial;
    }
  }
  table-layout: fixed;
  width: 100%;
}

</style>
